import Select from "react-select";
import {Component} from "react";
import PropTypes from "prop-types";

/**
 * @typedef MySelectOption
 * @type {Object}
 * @property {string} label
 * @property {string|number} value
 */

const MySelect = class extends Component {
	static propTypes = {
		/**
		 * Should autofocus?
		 * @type {boolean}
		 */
		autoFocus: PropTypes.bool,
		/**
		 * Apply a className to the control
		 * @type {string}
		 */
		className: PropTypes.string,
		/**
		 * Apply classNames to inner elements with the given prefix
		 * @type {string}
		 */
		classNamePrefix: PropTypes.string,
		/**
		 * Is select disabled?
		 * @type {boolean}
		 */
		isDisabled: PropTypes.bool,
		/**
		 * Allow the user to select multiple values
		 * @type {boolean}
		 */
		isMulti: PropTypes.bool,
		/**
		 * Allow the user to search for matching options?
		 * @type {boolean}
		 */
		isSearchable: PropTypes.bool,
		/**
		 * Generate an HTML input with this name, containing the current value
		 * @type {string}
		 */
		name: PropTypes.string,
		/**
		 * Subscribe to change events
		 * @function
		 * @param {MySelectOption|undefined} option The chosen option
		 * @return {void}
		 */
		onChange: PropTypes.func,
		/**
		 * Specify the options the user can select from
		 * @type { Array<MySelectOption>}
		 */
		options: PropTypes.arrayOf(PropTypes.object),
		/**
		 * Change the text displayed when no option is selected
		 * @type {string}
		 */
		placeholder: PropTypes.string,
		/**
		 * Text to display when there are no options
		 * @function
		 * @param {string} inputValue The search text
		 * @return {string|null}
		 */
		noOptionsMessage: PropTypes.func,
		/**
		 * Control the current value
		 * @type {MySelectOption|null}
		 */
		value: PropTypes.object,
		/** @type {boolean} */
		menuIsOpen: PropTypes.bool,
		/** @function */
		onMenuOpen: PropTypes.func,
		/** @function */
		onMenuClose: PropTypes.func,
		/**
		 * @desc Control the value of the search input (changing this will update the available options)
		 * @desc If you don't provide these props, you can set the initial value of the state they control
		 * @type {string}
		 */
		inputValue: PropTypes.string,
		/**
		 * @function
		 * @param {string} inputText
		 * @return {void}
		 */
		onInputChange: PropTypes.func,
		/**
		 * Set the initial value of the control
		 * @type {MySelectOption}
		 */
		defaultValue: PropTypes.object,
		/**
		 * @desc set the initial open value of the menu
		 * @type {boolean}
		 */
		defaultMenuIsOpen: PropTypes.bool,
		/**
		 * @desc set the initial value of the search input
		 * @type {string}
		 */
		defaultInputValue: PropTypes.string,
	};
	render() {
		return (
			<Select
				menuPortalTarget={window.document.body}
				styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
				{...this.props }
			/>
		)
	}
}

export default MySelect;
